import { Odds as BposOddsV4, OddsFormat } from '@bpos';
import { Price } from '@bpos/v1/teaser';

import { Fraction } from './fraction';
import { Odds, emptyOdds } from './odds';
import { OddsOperations } from './operations';

export function convertFromBposOddsV4(odds: BposOddsV4): Odds {
    return OddsOperations.createOdds({
        odds: odds.european,
        numerator: odds.british.numerator,
        denominator: odds.british.denominator,
        americanOdds: odds.american,
    });
}

export function convertFromBposTeaserPrice(teaserPrice: Price): Odds {
    if (teaserPrice) {
        return OddsOperations.createOdds({
            odds: teaserPrice.decimal,
            numerator: teaserPrice.fraction.numerator,
            denominator: teaserPrice.fraction.denominator,
            americanOdds: teaserPrice.american,
        });
    }

    return emptyOdds;
}
export function isEqual(first: Odds, second: Odds, oddsFormat: OddsFormat): boolean {
    switch (oddsFormat) {
        case OddsFormat.British:
            return Fraction.fromJSON(first.fractional).equal(Fraction.fromJSON(second.fractional));
        case OddsFormat.American:
            return first.moneyline === second.moneyline;
        default:
            return first.decimals === second.decimals;
    }
}
